import {AfterViewInit, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {SecurityService} from './security/security.service';
import {NavigationEnd, Router} from '@angular/router';
import {LoadingService} from "./utility/services/loading.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'SYL Interpreters Portal';
  isLoading = false;

  constructor(private router: Router,
              private securityService: SecurityService,
              private loadingService: LoadingService,
              private cdRef: ChangeDetectorRef
  ) {

  }

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0)
    });
    this.securityService.checkAuth().subscribe();
  }

  updateLoadingStatus(loadingStatus: boolean) {
    this.isLoading = loadingStatus
  }
}
